export const getMultiVideoListViewStyles = () => ({
  videoContainerStyle: {
    position: 'relative',
    width: '112px',
    height: '99px',
    borderRadius: '8px',
    margin: '5px',
    '&:hover, &:focus': {
      outline: '2px solid black',
    },
    '&:hover $hoverButtonsStyle, &:focus $hoverButtonsStyle': {
      display: 'block',
    },
    '&:hover .hover-button, &:focus .hover-button': {
      display: 'block',
    },
  },
  hoverButtonsStyle: {
    display: 'none',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 1,
  },
  videoThumbnail: {
    background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%)',
    borderRadius: 6,
    position: 'relative',
    width: '112px',
    height: '99px',
    margin: 5,
  },
  videoImageStyle: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: 6,
  },
  removeIconStyle: {
    color: '#106ebe',
    border: 'none',
    padding: 0,
    background: '#f3f2f1',
    backgroundColor: '#ffffffd4',
    borderRadius: '50%',
    width: '30px',
    height: '30px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  radioGroupContainer: {
    flexWrap: 'wrap',
    alignItems: 'center !important',
    '& .fui-Radio__label': {
      padding: 0,
    },
  },
  uploadingContainer: {
    zIndex: 10000,
    display: 'flex',
    position: 'absolute',
    backgroundColor: 'rgba(255,255,255,0.8)',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    gap: '8px',

    '& .radial-progress-text': {
      color: 'black !important',
    },
  },
  radioOption: {
    '& .fui-Radio__indicator': {
      position: 'absolute',
      top: 3,
      right: 3,
      width: 18,
      height: 18,
      background: 'white',
      zIndex: 1,
      display: 'none',
    },
    '&:hover .fui-Radio__indicator, &.selected .fui-Radio__indicator': {
      display: 'flex',
    },
    '&.selected $videoContainerStyle': {
      outline: '2px solid #0078d4',
    },
  },
  radioOptionHidden: {
    padding: '0 3px',
    '& .fui-Radio__indicator': {
      display: 'none',
    },
  },
});
